import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '@shared/services/auth.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class PublicAuthGuardService  {
  constructor(private authService: AuthService, private router: Router) {
    // console.log('Missing feature: actual auth guard logic');
  }

  canActivate(): Observable<boolean> {
    return this.authService.user$.pipe(
      map(user => {
        if (user) {
          return true
        } else {
          this.router.navigate(['/login'])
          return false
        }
      })
    )
  }
}
